import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Input, Field } from '@/components/ui/Field';
import { useAuth, can } from '@/lib/auth';
import { toast } from '@/components/ui/Toast';
import { useState as _useState } from 'react'; void _useState;

export function AdminsPage() {
  const { role } = useAuth();

  if (!can(role, 'manage_admins')) {
    return (
      <div className="mx-auto max-w-md text-center">
        <h1 className="display-serif text-3xl text-fg">403 — Owner access only</h1>
        <p className="mt-3 text-sm text-fg-muted">Only owners can manage other admins. Ask an owner to invite you.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <header>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">Admins</p>
        <h1 className="mt-2 display-serif text-display-l text-fg">Manage admins</h1>
        <p className="mt-2 text-sm text-fg-muted">Invite, change role, deactivate.</p>
      </header>

      <Card className="p-6">
        <h2 className="text-base font-semibold">Invite a teammate</h2>
        <p className="mt-1 text-sm text-fg-muted">
          Send a magic-link invite. They sign in, and you set their role afterwards.
        </p>
        <form
          className="mt-4 space-y-3"
          onSubmit={(e) => {
            e.preventDefault();
            const data = new FormData(e.currentTarget);
            const email = (data.get('email') as string)?.trim();
            if (!email) return;
            toast.success(`Invite queued for ${email}. They'll receive a magic link.`);
            (e.target as HTMLFormElement).reset();
          }}
        >
          <Field id="invite-email" label="Email" required>
            {({ id }) => <Input id={id} name="email" type="email" required placeholder="them@vonlof.co" />}
          </Field>
          <Button type="submit">Send invite</Button>
        </form>
      </Card>

      <Card className="p-6">
        <h2 className="text-base font-semibold">Note</h2>
        <p className="mt-2 text-sm text-fg-muted">
          Setting roles requires writing to <code>auth.users.app_metadata.role</code> via the service-role key, which
          is intentionally not exposed to the browser. Use Supabase Studio's SQL editor for role changes:
        </p>
        <pre className="mt-2 overflow-x-auto rounded-md border border-border bg-bg p-3 font-mono text-xs text-fg">
{`update auth.users
set app_metadata = coalesce(app_metadata, '{}'::jsonb)
                     || jsonb_build_object('role', 'admin')
where email = 'them@vonlof.co';`}
        </pre>
      </Card>
    </div>
  );
}